module.exports = __webpack_public_path__ + "images/柏纳长图_05.png?v=12d85314";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan1/柏纳长图_05.png
 ** module id = 144
 ** module chunks = 1 2
 **/